export enum VoiceCheckPage {
  Media = 'media',
  MediaError = 'mediaError',
  Record = 'record',
}
